export default __webpack_public_path__ + "static/media/392.165850fb.gif";